import type { ReactNode } from 'react'
import { forwardRef } from 'react'

import type { HeadingProps } from '@adverity/ds-component/heading'
import { Heading } from '@adverity/ds-component/heading'
import { Text } from '@adverity/ds-component/text'

type Props = {
    children: ReactNode
} & Omit<HeadingProps, 'level' | 'asChild'>

export const DialogTitle = forwardRef<HTMLHeadingElement, Props>(({ children, ...props }, ref) => (
    <Heading ref={ref} level={3} asChild className="flex min-w-0 whitespace-normal" {...props}>
        <h2>
            <Text className="max-w-full" textStyle="inherit" truncate={1}>
                {children}
            </Text>
        </h2>
    </Heading>
))

DialogTitle.displayName = 'DialogTitle'
